export enum ContextOrderEnum {
    EditNewOrder = "EditNewOrder",
    EditOptimizeSubscription = "EditOptimizeSubscription",
    EditPendingOrder = "EditPendingOrder",
    SeeClosedOrder = "SeeClosedOrder",
    CancelOptionPending = "CancelOptionPending"
}
